import Swiper from 'swiper/bundle';

const ImageGalleryVideo = () => {
  const sliders = document.querySelectorAll('.image-gallery-video__swiper');

  console.log(sliders);

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (!(slider instanceof Element)) return;

    const swiperWrapper = slider.querySelector('.image-gallery-video__swiper-wrapper');
    if (!swiperWrapper) return;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: slider.querySelector('.image-gallery-video__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.image-gallery-video__nav--next'),
        prevEl: slider.querySelector('.image-gallery-video__nav--prev'),
      },
    });
  });
};

export default ImageGalleryVideo;
